import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";

export default function EditorialMarquee() {
  const { t } = useLang();
  return (
    <section
      data-testid="marquee-section"
      className="border-b border-[#27272A] py-6 md:py-8 bg-brand overflow-hidden"
    >
      <Marquee speed={60} gradient={false} autoFill>
        {t.marquee.map((word, i) => (
          <div key={`${word}-${i}`} className="flex items-center">
            <span className="font-cabinet font-black uppercase text-4xl md:text-6xl tracking-tight px-6 text-white">
              {word}
            </span>
            <span className="font-cabinet font-black text-4xl md:text-6xl text-[#09090B]">/</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
